<template>
  <div class="message-sent">
    <div v-if="sentStatus === 'success'" class="d-flex flex-column align-center">
      <v-img :src="imgMessageOk" width="160" />
      <div class="mt-6">
        <div class="caption text-center">Ваше обращение успешно отправлено!</div>
        <p class="paragraph-m_h text-center text-secondary mt-2">Наши менеджеры свяжутся с вами в ближайшее время.</p>

        <e-btn v-if="!hideSendAgainButton" variant="primary" class="mt-6" @click="sendNewMessage"
          >Отправить новое сообщение
        </e-btn>
      </div>
    </div>
    <div v-else class="d-flex flex-column align-center">
      <v-img :src="imgMessageError" width="160" />
      <div class="mt-6">
        <div class="caption text-center">Что-то пошло не так, Ваше обращение не было отправлено!</div>
        <div class="paragraph-m_h text-secondary mt-2">
          Вы можете направить обращение на почту
          <a href="mailto:helpdesk@extranet.ru" class="link">helpdesk@extranet.ru</a>. Скопируйте сформированное
          сообщение и прикрепите к письму необходимые файлы.
        </div>

        <e-textarea :model-value="message" readonly label="Скопируйте сформированное сообщение" class="mt-6" :rows="20">
          <template #append-inner>
            <copy-to-clipboard :text="message" />
          </template>
        </e-textarea>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import imgMessageError from '@/assets/img/pages/support/error.svg';
import imgMessageOk from '@/assets/img/pages/support/ok.svg';
import CopyToClipboard from '@/core/components/buttons/CopyToClipboard.vue';
import { EBtn, ETextarea } from '@/core/components/ui';

defineProps<{
  sentStatus: 'success' | 'error';
  message: string;
  hideSendAgainButton?: boolean;
}>();

const emit = defineEmits<{
  (event: 'sendNewMessage'): void;
}>();

const sendNewMessage = () => {
  emit('sendNewMessage');
};
</script>

<style scoped lang="scss">
.message-sent {
  text-align: center;
}
</style>
